import router from "../router";
import store from "../store";
import {GET_USER_NOTIFICATION, UPDATE_NOTIFICATION} from "../store/actions.type";

const READ_ACTION = 'read';
const DELETE_ACTION = 'delete';

var notificationModalDialog = 'notificationModalDialog';

export function setNotificationModalDialog(appModal) {
  notificationModalDialog = appModal;
}

export function notificationResolver(notification) {
  if (notification.type === 'Admin') {
    notificationModalDialog.showAdminNotifyModal = true;
    notificationModalDialog.adminNotifyTitle = notification.data.title;
    notificationModalDialog.adminNotifyBody = notification.data.data.notification_body;
  } else {
    let query = '';
    router.push(notification.data.data.url + query);
  }
  markNotification_AsRead(notification);
}

export function markNotification_AsRead(notification) {
  if (!notification.data.data.read_at)
    markNotification_AsRead_ById(notification.id);
}

export function markNotification_AsRead_ById(id) {
  performNotificationAction(id, READ_ACTION);
}

export function deleteNotification(ids) {
  performNotificationAction(ids, DELETE_ACTION);
}

export function performNotificationAction(ids, actionType, count) {
  // alert('update and refresh notification! '+ids+' : '+actionType+' : '+count);
  // return;
  store.dispatch(UPDATE_NOTIFICATION, [ids, actionType]).then(response => {
    if (response.success) {
      getNotifications(count);
    }
  });
  return true;
}

export function getNotifications(count) {
  if (!count) {
    count = 20;
  }
  store.dispatch(GET_USER_NOTIFICATION, count);
}
